var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 52,
    height: 52,
    rx: 8,
    fill: "#F5F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.975 39.3638C19.93 39.3638 19.87 39.3938 19.825 39.3938C16.915 37.9538 14.545 35.5688 13.09 32.6588C13.09 32.6138 13.12 32.5538 13.12 32.5088C14.95 33.0488 16.84 33.4538 18.715 33.7688C19.045 35.6588 19.435 37.5338 19.975 39.3638Z",
    fill: "#1C9FDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.9101 32.6738C38.4251 35.6588 35.9501 38.0738 32.9351 39.5288C33.5051 37.6238 33.9851 35.7038 34.3001 33.7688C36.1901 33.4538 38.0501 33.0488 39.8801 32.5088C39.8651 32.5688 39.9101 32.6288 39.9101 32.6738Z",
    fill: "#1C9FDA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.0301 19.5638C38.1401 18.9938 36.2351 18.5288 34.3001 18.1988C33.9851 16.2638 33.5201 14.3438 32.9351 12.4688C36.0401 13.9538 38.5451 16.4588 40.0301 19.5638Z",
    fill: "#1C9FDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.975 12.6339C19.435 14.4639 19.045 16.3239 18.73 18.2139C16.795 18.5139 14.875 18.9939 12.97 19.5639C14.425 16.5489 16.84 14.0739 19.825 12.5889C19.87 12.5889 19.93 12.6339 19.975 12.6339Z",
    fill: "#1C9FDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.735 17.884C28.255 17.494 24.745 17.494 21.265 17.884C21.64 15.829 22.12 13.774 22.795 11.794C22.825 11.674 22.81 11.584 22.825 11.464C24.01 11.179 25.225 10.999 26.5 10.999C27.76 10.999 28.99 11.179 30.16 11.464C30.175 11.584 30.175 11.674 30.205 11.794C30.88 13.789 31.36 15.829 31.735 17.884Z",
    fill: "#1C9FDA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.385 31.2337C16.315 30.8587 14.275 30.3787 12.295 29.7037C12.175 29.6737 12.085 29.6887 11.965 29.6737C11.68 28.4887 11.5 27.2737 11.5 25.9987C11.5 24.7387 11.68 23.5087 11.965 22.3387C12.085 22.3237 12.175 22.3237 12.295 22.2937C14.29 21.6337 16.315 21.1387 18.385 20.7637C18.01 24.2437 18.01 27.7537 18.385 31.2337Z",
    fill: "#1C9FDA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 25.9987C41.5 27.2737 41.32 28.4887 41.035 29.6737C40.915 29.6887 40.825 29.6737 40.705 29.7037C38.71 30.3637 36.67 30.8587 34.615 31.2337C35.005 27.7537 35.005 24.2437 34.615 20.7637C36.67 21.1387 38.725 21.6187 40.705 22.2937C40.825 22.3237 40.915 22.3387 41.035 22.3387C41.32 23.5237 41.5 24.7387 41.5 25.9987Z",
    fill: "#1C9FDA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.735 34.1143C31.36 36.1843 30.88 38.2243 30.205 40.2043C30.175 40.3243 30.175 40.4143 30.16 40.5343C28.99 40.8193 27.76 40.9993 26.5 40.9993C25.225 40.9993 24.01 40.8193 22.825 40.5343C22.81 40.4143 22.825 40.3243 22.795 40.2043C22.135 38.2093 21.64 36.1843 21.265 34.1143C23.005 34.3093 24.745 34.4443 26.5 34.4443C28.255 34.4443 30.01 34.3093 31.735 34.1143Z",
    fill: "#1C9FDA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.145 31.644C28.3934 32.1174 24.6066 32.1174 20.855 31.644C20.3817 27.8924 20.3817 24.1057 20.855 20.354C24.6066 19.8807 28.3934 19.8807 32.145 20.354C32.6183 24.1057 32.6183 27.8924 32.145 31.644Z",
    fill: "#1C9FDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.584d5b4430aa872eeb1eb0dd5345ddc9.svg";
export { ForwardRef as ReactComponent };